import React, { Component, useEffect, useState } from 'react';
import { Col, Container, Row, Table, Button, CardDeck, Card, CardBody, CardImg, Tooltip, Carousel, CarouselControl, CarouselItem, CarouselIndicators, ModalHeader, ModalBody, Input, ModalFooter } from 'reactstrap';
import API from '../API';
import { Apify, ApifyParallel, ApifyFullScreenLoadingComponent } from '../Apify';
import { connect } from 'react-redux';
import I18N from '../I18N';
import { PrivatePortfolio } from '../c/Portfolio';
import QueuedTrades from './QueuedTrades';
import Butt from './Butt';
import { A, BlessLink, R } from '../routes';
import ChangeArrow from './ChangeArrow';
import { T, TraksConsumer } from '../traks';
import {LinkField, ShareURL } from './ShareURL';
import { RangedChart, LargeChartInner } from './Chart';
import Markets from './Markets';
import store from '../store';
import ActionLink from './ActionLink';
import { OpenLoginWithSuccessCallback, OpenSignupAndJoinGame } from './SignupLogin';
import { PublicGameCard } from './ChartCard';
import XTab from './XTab';
import { WaitUntilVisible } from '../Visibility';
import { coalesce, segmentize, array2set } from '../misc';
import PieHole from './PieHole';
import FancyNumber from './FancyNumber';
import Logo from './Logo';
import { SkinWrapperByGameOrPortfolioId, SkinContext, SR } from '../skin';
import { WhiteBox } from './lib';
import InlineSVG from './InlineSVG';
import { AUAContainer } from '../AUA';
import { current_site_id, short_site_id, site_name, site_base } from '../Site';
import random_id from '../random_id';
import { market_order_key_map } from '../markets';
import CooldownInput from './CooldownInput';
import GoogleAnalytics from '../GoogleAnalytics';
import { AdminActionsModalInit } from './AdminActionsModal';
import { UpgradeToPremiumModalInit } from './UpgradeToPremium'

function placementAndNumPlayers(game, portfolios) {
	var number_of_players;
	var my_placement;

	for(var i = 0; i < portfolios.length; i++) {
		if(portfolios[i].Id === game.MyPortfolioId) {
			my_placement = portfolios[i].Place;
		}
		/* Assuming the last portfolio is the last in the game */
		number_of_players = portfolios[i].Place;
	}

	return {my_placement: my_placement, number_of_players: number_of_players};
}

class Invite extends Component {
	constructor(props) {
		super(props);
		this.state = {regen_confirmation_required: false};
	}

	render() {
		const info = this.props.info;

		const nowTs = Date.now();
		let inviteEndTs = 0;
		if (info.InviteEndTs) {
			inviteEndTs = new Date(info.InviteEndTs).getTime();
		}
		
		if (info === null) return null;

		const do_regen = () => {
			API.post("/a/reset_game_invite", {game_id: this.props.game_id}, (ok) => {
				this.setState({regen_confirmation_required: false});
				this.props.ctl.reload();
			});
		};
        
        const gameTypeFree = <T>free</T>
        const gameTypePro = <T>pro</T>

		var invite_options, regen;
		if (info.URL.length > 0) {
            var inviteFriendsElement;
            if (
                ((info.GameType === 'free' && info.RemainingFreeInvites > 0) || (info.RemainingProInvites > 0 && info.GameType === 'pro'))
                && inviteEndTs > nowTs && info.HasSkinId === false
            ) {
                inviteFriendsElement = (
                    <React.Fragment>
                        <div className="py-2 font-small"><T>Share the link below with people you want to invite to the game.</T></div>
                        <ShareURL url={info.URL} css_classes="mb-2" />
                        <div className="pb-3 font-small"><T>You have {info.GameType === 'free' ? info.RemainingFreeInvites : info.RemainingProInvites} {info.GameType === 'free' ? gameTypeFree : gameTypePro} invites left</T></div>
                    </React.Fragment>
                )
            } else if (
                ((info.GameType === 'free' && info.RemainingFreeInvites === 0) || (info.RemainingProInvites === 0 && info.GameType === 'pro'))
                && info.HasSkinId === false
            ) {
                inviteFriendsElement = (
                    <React.Fragment>
                        <div className="py-2"><T>No invites left</T></div>
                    </React.Fragment>
                );
            } else if (inviteEndTs !== 0 && inviteEndTs >= 0 && inviteEndTs < nowTs) {
				inviteFriendsElement = (
					<React.Fragment>
						<div className="py-2"><T>The time for invitations has expired</T></div>
					</React.Fragment>
				)
			}
			else {
                inviteFriendsElement = (
                    <React.Fragment>
                        <div className="py-2 font-small"><T>Share the link below with people you want to invite to the game.</T></div>
                        <ShareURL url={info.URL} css_classes="mb-2" />
                        {info.HasSkinId === false && <div className="pb-3 font-small"><T>You have {info.GameType === 'free' ? info.RemainingFreeInvites : info.RemainingProInvites} {info.GameType === 'free' ? gameTypeFree : gameTypePro} invites left</T></div>}
                    </React.Fragment>
                );
            }
            invite_options = (
                <Row className="ad_game">
                    <Col xs="12" className="pl-2 pl-md-4">
                        <div className="pt-3 ad_150pct"><b><T>Invite your friends</T></b></div>
                        {inviteFriendsElement}
                    </Col>
                </Row>
            );

			const do_regen_maybe = () => this.setState({regen_confirmation_required: true});
			if (this.props.info.IsGod) {
            if (this.state.regen_confirmation_required === false) {
				regen = <Row><Col xs="12" className="pl-2 pl-md-4"><Butt className="ad_btn_sm" onClick={do_regen_maybe}><T>Create new invite</T></Butt><span className="font-small pl-2"><T>(this will revoke all previous invites)</T></span></Col></Row>;
			} else {
				const do_cancel = () => {
					this.setState({regen_confirmation_required: false});
				};
				regen = (
					<div>
						<div><T>Are you sure you want to revoke this invite and make a new one?
						If you have already shared the link with anyone, they will no longer be able to use it.</T>
						</div>
						<Butt className="ad_btn_sm" onClick={do_regen}><T>Yes, do it!</T></Butt><span className="p-1"/>
						<Butt className="ad_btn_sm" onClick={do_cancel}><T>Cancel</T></Butt>
					</div>
				);
			}
        }
		} else {
			regen = <Butt onClick={do_regen}>Make invite</Butt>;
		}

		const leaderboard_url = "https://" + site_base + R.href("/leaderboard/:key", {key: info.LeaderboardKey});

		return (
		<React.Fragment>
			<div>
				<Row className="ad_game_box">
					<Col className="ad_invite_background" md="12">
						{invite_options}
						{regen && <div className="mt-5 mb-3">{regen}</div>}
					</Col>
				</Row>
			</div>
			<div className="py-4">
				<Row className="ad_game_box">
					<Col className="pl-2 pl-md-4 pb-3" md="12">
						<div className="pt-3 ad_150pct"><b><T>Leaderboard URL</T></b></div>
						<div className="py-2 font-small"><T>You can use this link for dashboards, etc.</T></div>
						<a href = {leaderboard_url}>
							<LinkField url={leaderboard_url} width_css="ad_width_33_rem"/>
						</a>
					</Col>
				</Row>
			</div>
		</React.Fragment>
		);
	}
}

const quotes_to_display = [
	{
		id: 1,
		txt: <T><b>Marc E., buddy gambler</b><br />
		</T>
	},
	{
		id: 2,
		txt: <T><b>Romario K., winner of Sommer Börsen Battle</b><br />
		</T>
	},
	{
		id: 3,
		txt: <T><b>Linus E., Battle lover</b><br />
		</T>
	},
	{
		id: 4,
		txt: <T><b>Ana S., portfolio tracker</b><br />
		</T>
	},
	{
		id: 5,
		txt: <T><b>Lukas H., 3rd place at Sommer Börsen Battle</b><br />
		</T>
	}

];

const QuotesFromPeople = (props) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [animating, setAnimating] = useState(false);

	const next = () => {
		if (animating) return;
		const nextIndex = activeIndex === quotes_to_display.length - 1 ? 0 : activeIndex + 1;
		setActiveIndex(nextIndex);
	}

	const previous = () => {
		if (animating) return;
		const nextIndex = activeIndex === 0 ? quotes_to_display.length - 1 : activeIndex - 1;
		setActiveIndex(nextIndex);
	}

	const goToIndex = (newIndex) => {
		if (animating) return;
		setActiveIndex(newIndex);
	}

	const slides = quotes_to_display.map((item) => {
		return (
			<CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.id} >
				<div className="pt-3 pb-5 quotes_from_people">
					{item.txt}
				</div>
			</CarouselItem>
	       );
	});

	return (
		<React.Fragment>
			<Row className="pt-4">
				<Col xs="12">
					<div className="text-center ad_front_heading">
						<b><T>See what other {site_name} players have to say</T></b>
					</div>
				</Col>
			</Row>
			<Row className="py-4">
				<Col md="3" />
				<Col md="6">
					<div>
						<img alt="quotes" src="https://static.aktiedysten.dk/gfx/quote-sign-2023-0.svg" />
					</div>
					<Carousel activeIndex={activeIndex} next={next} previous={previous}>
						<CarouselIndicators items={quotes_to_display} activeIndex={activeIndex} onClickHandler={goToIndex} />
						{slides}
						<div className="d-none d-md-block">
							<CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
							<CarouselControl direction="next" directionText="Next" onClickHandler={next} />
						</div>
					</Carousel>
				</Col>
				<Col md="3" />
			</Row>
		</React.Fragment>
       );
}

const bless_text = (txt) => {
	const link_re = /https?:\/\/[^ ]+/;
	const trailing_re = /[.,?!]+$/;
	var fs = [];
	var remaining = txt;

	const next_key = (() => {
		var next_id = 1;
		return () => next_id++;
	})();
	const span = (x) => <span key={next_key()}>{x}</span>;
	const link = (x) => <a target="_blank" rel="noopener noreferrer" className="ad_blue_link" href={x} key={next_key()}>{x}</a>

	for (;;) {
		const index = remaining.search(link_re);
		if (index === -1) {
			fs.push(span(remaining));
			break;
		} else {
			var match = remaining.match(link_re)[0];
			match = match.replace(trailing_re, "");
			var n = match.length;
			fs.push(span(remaining.substr(0, index)));
			fs.push(link(remaining.substr(index, n)));
			remaining = remaining.substr(index+n);
		}
	}
	return fs;
};

const GamePieInner = (props) => {
	if (props.error) {
		if (props.fallback_element) {
			return props.fallback_element;
		} else {
			return null;
		}
	} else if (!props.values) {
		return null;
	} else {
		var k;
		var prepared_values = {};
		for (k in props.values) {
			var k2;
			switch (k) {
			case "BANK":
				continue;
			case "NASDAQ":
			case "NYSE":
			case "IDX-USD":
				k2 = "#us";
				break;
			case "OPEC":
			case "LBMA":
			case "LME":
			case "BRENT":
				k2 = "#commodity";
				break;
			case "CPH":
			case "IDX-DKK":
				k2 = "CPH";
				break;
			case "STO":
			case "IDX-SEK":
				k2 = "STO";
				break;
			case "HEL":
			case "IDX-HEL":
				k2 = "HEL";
				break;
			case "XETRA":
			case "WBAG":
			case "#cash":
			case "#currency":
			case "CRYPTO":
			case "ICE":
				k2 = k;
				break;
			default:
				continue;
			}
			if (prepared_values[k2] === undefined) prepared_values[k2] = 0;
			prepared_values[k2] += props.values[k];
		}

		/* merge nordic stock into #nordic in case we're seeing more
		 * than one of the following */
		const nordic = ["CPH", "STO", "HEL", "ICE"];
		var nordic_count = 0;
		var nordic_sum = 0;
		for (const k of nordic) {
			if (!prepared_values[k]) continue;
			nordic_sum += prepared_values[k];
			nordic_count++;
		}
		if (nordic_count >= 2) {
			for (const k of nordic) delete prepared_values[k];
			prepared_values["#nordic"] = nordic_sum;
		}

		var pie_values = [];
		for (k in prepared_values) {
			var em;
			switch (k) {
			case "#us":
				em = <span><T context="American stocks">American</T></span>;
				break;
			case "CPH":
				em = <span><T context="Danish stocks">Danish</T></span>;
				break;
			case "STO":
				em = <span><T context="Swedish stocks">Swedish</T></span>;
				break;
			case "HEL":
				em = <span><T context="Finnish stocks">Finnish</T></span>;
				break;
			case "ICE":
				em = <span><T context="Icelandic stocks">Icelandic</T></span>;
				break;
			case "#nordic":
				em = <span><T context="Nordic stocks">Nordic</T></span>;
				break;
			case "#commodity":
				em = <span><T>Commodities</T></span>;
				break;
			case "#cash":
				em = <span><T>Cash</T></span>;
				break;
			case "#currency":
				em = <span><T>Currencies</T></span>;
				break;
			case "CRYPTO":
				em = <span><T>Crypto</T></span>;
				break;
			default:
				continue;
			}

			pie_values.push([prepared_values[k], em]);
		}

		const pie_size = coalesce(props.pie_size, 200);

		const Titled = (props) => <T><div title="The distribution of equities across all players in the game.">{props.children}</div></T>

		return (
			<Titled>
				<PieHole
					seq={props.count}
					pie_size={pie_size}
					values={pie_values}
					legend_header={<b><T>Game equities</T></b>}
					container_class={props.container_class}
					wedges_class={props.wedges_class}
					legend_class={props.legend_class}
				/>
			</Titled>
		);
	}
};

const GamePie = Apify("/z/game_category_values")
	.with_query_from_props((props) => ({game_id: props.game_id}))
	.with_response_prop("values")
	.with_count_prop()
	.with_4xx_prop()
	.with_ctl_prop()
	.wrap(GamePieInner, (props) => <span/>);

const GameStats = Apify("/z/game_stats")
	.with_query_from_props((props) => ({game_id: props.game_id, lang: R.get_current_language()}))
	.with_response_prop("stats")
	.with_4xx_prop()
	.wrap((props) => {

	const stats = props.stats;
	if (!stats) return null;
	const trade_count = stats.TradeCount;
	const total_trade_sum = stats.TradeAmount;
	const most_traded = stats.MostTradedStock;

	const trade_count_element = (
		<React.Fragment>
			<div className="ad_home_summary_bottom_headline"><T>TRADE COUNT:</T></div>
			<div className="ad_home_summary_bottom_numbertxt"><FancyNumber method="count" value={trade_count}/></div>
		</React.Fragment>
	);

	const total_trade_sum_element = (
		<React.Fragment>
			<div className="ad_home_summary_bottom_headline"><T>TOTAL TRADE SUM:</T></div>
			<div className="ad_home_summary_bottom_numbertxt"><FancyNumber value={total_trade_sum} unit={stats.Currency}/></div>
		</React.Fragment>
	);

	const most_traded_element = (
		<React.Fragment>
			<div className="ad_home_summary_bottom_headline"><T>MOST TRADED:</T></div>
			<A className="ad_white_link" href={R.href("/ticker/:exchange/:ticker", {exchange: most_traded.Exchange, ticker: most_traded.Ticker})}>
				<div className="d-flex justify-content-center mt-3">
					<Logo size="36" exchange={most_traded.Exchange} ticker={most_traded.Ticker}/>
					<div className="pl-2 text-left">
						<div className="ad_home_summary_bottom_stock_text_adjust ad_home_summary_bottom_stock_title">{most_traded.Ticker}</div>
						<div className="ad_home_summary_bottom_stock_text_adjust ad_home_summary_bottom_stock_subtitle">{most_traded.Name}</div>
					</div>
				</div>
			</A>
		</React.Fragment>
	);

	return (
		<div className="ad_home_summary_bottom w-100 ad_home_summary_text_fg">
			<div className="d-none d-md-flex flex-row p-4">
				<div className="ad_home_summary_border_right flex-fill text-center">
					{trade_count_element}
				</div>
				<div className="ad_home_summary_border_right flex-fill text-center">
					{total_trade_sum_element}
				</div>
				<div className="text-center flex-fill">
					{most_traded_element}
				</div>
			</div>
			<div className="d-flex d-md-none flex-column p-4">
				<div className="text-center flex-fill pb-4">
					{most_traded_element}
				</div>
				<div className="flex-fill text-center pb-3">
					{trade_count_element}
				</div>
				<div className="flex-fill text-center">
					{total_trade_sum_element}
				</div>
			</div>
		</div>
	);
});

const mk_std_game_bullets = (game) => {
	const end_date_str = I18N.datetime_short(new Date(game.EndTime * 1000));
	return [
		(
			<tr key="markets">
				<td className="py-1"><img alt="target_markets" className="ad_summary_icons ad_margin_bottom_2px" src="/gfx/target-markets-0.svg"/></td>
				<td className="px-2 py-1"><span className="ad_summary_text pr-2"><T>Markets:</T></span><Markets market_link_class="ad_white_link" market_txt_class="ad_summary_text_markets" markets={game.Markets}/></td>
			</tr>
		),
		(
			<tr key="end_date">
				<td className="py-1"><img alt="target_markets" className="ad_summary_icons ad_margin_bottom_2px" src="/gfx/watch-time-icon-0.svg"/></td>
				<td className="px-2 py-1"><span className="ad_summary_text pr-2"><T>Ends:</T></span><b>{end_date_str}</b></td>
			</tr>
		),
	];
};

const RawGameSummary = (props) => {
	const { game, headline, bullets } = props;

	var stuff_to_the_right;
	if (game) {
		stuff_to_the_right = (
			<div className="d-none d-md-block pl-md-5">
				<div className="ad_not_empty"></div>
				<WaitUntilVisible>
					{game && <GamePie game_id={game.Id}/>}
				</WaitUntilVisible>
			</div>
		);
	}

	return (
		<Row className="pb-4 pt-3">
			<Col className="px-0">
				<Container fluid className="ad_home_summary p-0">
					<div className="p-4">
						<div className="d-flex justify-content-between ad_home_summary_text_fg">
							<div>
								{headline && 
									<div className="d-flex flex-row justify-content-between pb-3">
										<div className="pr-5 mb-0 ad_explore_txt_subheader align-self-center">
											{headline}
										</div>
									</div>
								}
								<table>
									<tbody>
										{bullets}
									</tbody>
								</table>
							</div>
							{stuff_to_the_right}
						</div>
						<div className="d-block d-md-none pl-md-5 mt-2">
							<div className="ad_not_empty"></div>
							<WaitUntilVisible>
								{game && <GamePie
									game_id={game.Id}
									pie_size={150}
									container_class="d-flex"
									wedges_class="d-flex align-items-center"
									legend_class="d-flex align-items-center ad_piehole_small_legend ad_home_summary_text_fg"
								/>}
							</WaitUntilVisible>
						</div>
					</div>
					{game && <GameStats game_id={game.Id}/>}
				</Container>
			</Col>
		</Row>
	);
};

const ActiveGameSummary = (props) => {
	const { me, game, show_game_change_button } = props;
	var welcome;
	if (me) {
		var personal_name = me.ScreenName;
		if (personal_name.length === 0) personal_name = me.FacebookName;
		if (personal_name.length === 0) personal_name = me.TwitterName;
		if (personal_name.length === 0) personal_name = me.LocalEmail;
		if (personal_name.length === 0) personal_name = 'Howca Ni Notknow';
		welcome = <React.Fragment><T>Welcome</T><span className="d-none d-md-inline-block">, {personal_name}</span></React.Fragment>
	}

	var game_change_button;
	if (show_game_change_button) {
		game_change_button = (
			<BlessLink>
				<span className="pr-2">
					<A href="/games">
						<Button size="sm" className="ad_select_game_summary_btn">
							<div className="d-table-cell">
								<div className="d-table-cell">
									<img className="pl-1" alt="change game" src="/gfx/change-game-icon-0.svg" />
								</div>
								<div className="d-table-cell px-1 px-md-2" style={{paddingTop: "1px", verticalAlign: "bottom"}}>
									<T context="Change game">Change</T>
								</div>
							</div>
						</Button>
					</A>
				</span>
			</BlessLink>
		);
	}

	var bullets;

	if (game) {
		const can_admin = array2set(game.Admins)[me.Id];
		let edit_game_button;
		if (can_admin) {
			edit_game_button = (
				<A className="ad_edit_game_link"  href={R.href("/edit_game/:game_id", {game_id: game.Id})}>
					<span className="pl-2">
						<img className="ad_edit_game_icon" alt="change game" src="/gfx/anothergear-icon-0.svg" />
						<T context="Edit game">Edit</T>
					</span>
				</A>
			);
		}

		const {my_placement, number_of_players} = placementAndNumPlayers(game, game.Portfolios);
		const placement_text = <T><span className="pr-2">Ranking:</span><b>{my_placement}</b> of <b>{number_of_players}</b> player(s).</T>;
		const std_bullets = mk_std_game_bullets(game);
		bullets = [
			(
				<tr key="active_game">
					<td className="py-0"><img alt="game_name" className="ad_summary_icons ad_margin_bottom_5px" src="/gfx/trophy-cup-outline-0.svg"/></td>
					<td className="px-2 py-0 ad_height_29px">
						<span className="ad_summary_text pr-2"><T>Active game:</T></span>
						<span className="ad_summary_game_active ad_underline pr-md-2">{game.Name}{edit_game_button}</span>
						<span className="pl-1">{game_change_button}</span>
					</td>
				</tr>
			),
			(
				<tr key="placement">
					<td className="py-1"><img alt="placement" className="ad_summary_icons ad_margin_bottom_3px" src="/gfx/achievements-won-cup-0.svg"/></td>
					<td className="px-2 py-1"><span className="ad_summary_text">{placement_text}</span></td>
				</tr>
			),
			...std_bullets,
		];
	} else {
		bullets = [
			(
				<tr key="no_active_game">
					<td className="py-0"><img alt="" className="ad_summary_icons ad_margin_bottom_5px" src="/gfx/trophy-cup-outline-0.svg"/></td>
					<td className="px-2 py-0">
						<span className="ad_summary_text pr-2"><T>You have no active game</T></span>
						<span className="pl-2">
							{game_change_button}
							<BlessLink><Button size="sm" className="ad_select_game_summary_btn ad_height_29px" href="/new_game"><span className="px-1 px-md-2"><T>Create game</T></span></Button></BlessLink>
						</span>
					</td>
				</tr>
			),
		];
	}

	return <RawGameSummary {...props} headline={welcome} bullets={bullets}/>
};

const LurkerGameSummary = (props) => {
	const { game } = props;
	var headline = <React.Fragment>{game.Name}</React.Fragment>
	const { number_of_players } = placementAndNumPlayers(game, game.Portfolios);
	const std_bullets = mk_std_game_bullets(game);

	var bullets = [
		(
			<tr key="number_of_players">
				<td className="py-1"><img alt="placement" className="ad_summary_icons ad_margin_bottom_3px" src="/gfx/achievements-won-cup-0.svg"/></td>
				<td className="px-2 py-1">
					<span className="ad_summary_text">
						<span className="pr-2">Number of players:</span><b>{number_of_players}</b>
					</span>
				</td>
			</tr>
		),
		...std_bullets,
		(
			<tr key="join_game">
				<td/>
				<td>
					<BlessLink><Button className="ad_join_game_summary_btn" href={R.href("/invite/:id", {id: game.Id})}>
						<img alt="game_name" className="ad_summary_icons ad_margin_bottom_2px" src="/gfx/trophy-cup-outline-0.svg"/>
						<span className="px-1 px-md-2"><T>Join game!</T></span>
					</Button></BlessLink>
				</td>
			</tr>
		),
	];
	return <RawGameSummary {...props} headline={headline} bullets={bullets}/>
};

const GameChatBeforeIdImpl = (props) => {
	const [msg_input, set_msg_input] = useState("");
	const [before_id_stack, set_before_id_stack] = useState([]);
	const [confirm_delete_msg_id, set_confirm_delete_msg_id] = useState(0);
	const [cooldown_until_ts, set_cooldown_until_ts] = useState(null);

	const is_admin = array2set(props.admins)[props.me.Id];

	const reset = () => {
		props.set_before_id(0);
		set_before_id_stack([]);
		props.ctl.reload();
	};

	var msgs;
	var ctrls;
	if (props.before_id === 0 && props.chat.Messages.length === 0) {
		msgs = <div><T>No messages yet... type a message in the field above</T></div>;
	} else {
		msgs = [];
		var min_msg_id = undefined;
		for (const msg of props.chat.Messages) {
			if (min_msg_id === undefined || msg.Id < min_msg_id) min_msg_id = msg.Id;
			const mk_delete_msg = (msg) => {
				const can_delete = is_admin || msg.UserId === props.me.Id;
				if (can_delete) {
					if (confirm_delete_msg_id === msg.Id) {
						const do_delete = () => {
							API.post("/a/delete_game_chat_msg", {id: msg.Id}, (ok) => {
								set_confirm_delete_msg_id(0);
								props.ctl.reload();
							});
						};
						const do_cancel = () => {
							set_confirm_delete_msg_id(0);
						};
						return (
							<span>
								<span className="pr-2"><T>Delete message?</T></span>
								<span className="ad_blue_link pr-2"><ActionLink on_click={do_delete}><T>Yes</T></ActionLink></span>
								<span className="ad_blue_link"><ActionLink on_click={do_cancel}><T>No</T></ActionLink></span>
							</span>
						);
					} else {
						const confirm_delete = () => set_confirm_delete_msg_id(msg.Id);
						return <ActionLink on_click={confirm_delete}><img alt="" src="/gfx/remove-chat-msg-0.svg" /></ActionLink>;
					}
				} else {
					return null;
				}
			};

			var is_written_by_admin = array2set(props.admins)[msg.UserId];
			var admin_icon = is_written_by_admin ? <span><img alt="" title="Administrator" src="/gfx/admin-icon-0.svg" /></span> : null;

			var last_col;
			if (msg.Id === confirm_delete_msg_id) {
				last_col = <Col className="ad_gamechat_msg pb-1" xs="12" sm="12" md="8" lg="9">{mk_delete_msg(msg)}</Col>
			} else {
				last_col = <Col className="ad_gamechat_msg pb-1" xs="12" sm="12" md="8" lg="9">{mk_delete_msg(msg)}{bless_text(msg.Msg)}</Col>
			}

			msgs.push(
				<Row key={msg.Id}>
					<Col className="ad_gamechat_date" xs="3" sm="3" md="2" lg="1">{I18N.datetime_shorter(new Date(msg.Ts*1000))}</Col>
					<Col className="ad_gamechat_name" xs="9" sm="9" md="2" lg="2">
						<A href={"/portfolio/" + msg.PortfolioId}>
							{admin_icon}{props.chat.UserIdNameMap[msg.UserId]}
						</A>
					</Col>
					{last_col}
				</Row>
			);
		}

		ctrls = [];

		if (props.chat.More) {
			const view_older = () => {
				set_before_id_stack([...before_id_stack, props.before_id]);
				props.set_before_id(min_msg_id);
			};
			ctrls.push(
				<span key="view_older" className="pr-3"><ActionLink on_click={view_older} className="ad_gamechat_ctrl"><T>Older&hellip;</T></ActionLink></span>
			);
		} else {
			ctrls.push(
				<span key="view_older" className="ad_gamechat_ctrl_disabled pr-3"><T>Older&hellip;</T></span>
			);
		}

		if (props.before_id > 0) {
			const view_newer = () => {
				var id = 0;
				if (before_id_stack.length > 0) {
					id = before_id_stack[before_id_stack.length-1];
					set_before_id_stack(before_id_stack.slice(0, before_id_stack.length-1));
				}
				props.set_before_id(id);

			};
			ctrls.push(
				<span key="view_newer" className="pr-3"><ActionLink on_click={view_newer} className="ad_gamechat_ctrl"><T>Newer&hellip;</T></ActionLink></span>
			);

			if (before_id_stack.length >= 2) {
				const view_newest = () => reset();
				ctrls.push(
				       <span key="view_newest"><ActionLink on_click={view_newest} className="ad_gamechat_ctrl"><T>Back</T></ActionLink></span>
				);
			}
		}
	}

	var form;

	if (props.can_post) {
		const chat_input_placeholder = props.render_static(<T>Compose your post here...</T>);
		const write_msg = (e) => {
			e.preventDefault();
			const args = {
				game_id: props.game_id,
				msg: msg_input,
			};
			API.post("/a/game_chat_msg", args, (response) => {
				set_cooldown_until_ts(response.CooldownUntilTs);
				if (response.Duplicate) {
					// dupe
				} else if (!response.Posted) {
					// not posted due to cooldown
				}
				reset()
			});
			set_msg_input("");
		}

		const on_change = (e) => {
			set_msg_input(e.target.value);
		}

		form = (
			<form onSubmit={write_msg}>
				<Row className="pb-3">
					<Col md="4" className="pr-md-0">
						<CooldownInput
							placeholder={chat_input_placeholder}
							name="msg"
							className="ad_chat_input w-100 ad_no_outline_focus"
							value={msg_input}
							onChange={on_change}
							autoComplete="off"
							cooldown_until_ts={cooldown_until_ts}
							render_static={props.render_static}
						/>
					</Col>
				</Row>
			</form>
		);
	}

	return (
		<Row className="ad_game_box mb-4">
			<Col className="ad_150pct pl-4 pr-md-0" xs="12" md="6">
				<div className="d-flex justify-content-between">
					<div className="pt-3 pb-3"><b><T>Share your experiences</T></b>
					<div style={{fontSize: "11px"}}>(<T>This forum is for sharing experiences/considerations
					with other players in order to learn and get inspired. Do you
					need support, please send an email to info@{site_base}.
					Furthermore, we would like to stress that obscene language,
					condescending behaviour, spam, etc. will result in message and
					user account <strong>deletion without warning</strong>.</T>)</div>
					</div>
				</div>
			</Col>
			<Col xs="12" className="pl-2 pl-md-4 pb-4">
				{form}
				{msgs}
				{ctrls}
			</Col>
		</Row>
	);
}

const GameChatBeforeId = Apify("/a/game_chat")
		.with_query_from_props(props => ({game_id: props.game_id, before_id: props.before_id}))
		.with_response_prop("chat")
		.with_ctl_prop()
		.wrap(GameChatBeforeIdImpl);

const GameChat = connect(
	(state) => ({me: state.me})
)((props) => {
	/* Chat disabling for public games in DK and SE */
	if ((IS_AKTIEDYSTEN_DK || IS_AKTIEKAMPEN_SE) && props.is_public) return null;
	if (!props.me || !props.me.Id) return null;

	const [before_id, set_before_id] = useState(0);
	return (
		<TraksConsumer>
			<GameChatBeforeId
				game_id={props.game_id}
				before_id={before_id}
				set_before_id={set_before_id}
				me={props.me}
				admins={props.admins}
				can_post={props.can_post}
			/>
		</TraksConsumer>
	);
});

Invite = Apify("/a/game_owner_invite_info")
    .with_query_from_props(props => ({game_id: props.game_id, site: short_site_id}) )
    .with_response_prop("info")
    .with_ctl_prop()
    .wrap(Invite);

const UpgradeGame = (props) => {
    const [gameType, setGameType] = useState(props.game.GameType)
    const [portfolioUpgrades, setPortfolioUpgrade] = useState(props.portfolios_upgrade)

    useEffect(() => {
        if (props.cart && props.cart.completed) {
            API.get("/a/portfolio_to_upgrade", {game_id: props.game.Id}, (response, status) => {
                if (status >= 200 && status < 300) {
                    setPortfolioUpgrade(response);
                }
            })
        }
    }, [props.cart])

    const triggerProUpgrade = () => {
        if (portfolioUpgrades.PortFoliosCount === 0 && props.me.Subscription === 'pro') {
            API.post("/a/set_game_type", {game_id: props.game.Id, game_type: "pro"}, (response) => {
				if (response === true) {
                    setGameType("pro");
                }
			});
        } else if (portfolioUpgrades.PortFoliosCount > portfolioUpgrades.RemainingProInvites || props.me.Subscription === 'free') {
            store.dispatch_value("show_cart_game_upgrade", {
                game_id: props.game.Id ? props.game.Id : 0,
                completed: false
            })
            store.dispatch_value('show_cart', true);
        } else {
            UpgradeToPremiumModalInit(props.game.Id, portfolioUpgrades.PortFoliosCount, portfolioUpgrades.RemainingProInvites, setGameType)
        }        
    }

    const triggerBuyMoreInvites = () => {
        store.dispatch_value("show_cart_game_upgrade", {
            game_id: props.game.Id,
            completed: false
        })
        store.dispatch_value('show_cart', true);
    }

    return (
		<Row className={`ad_game_box mb-4 ad_upsell_background ${gameType !== 'free' ? 'no-background' : ''}`}>
			<Col className="px-4 pr-md-0" xs="12" md="9">
				<div className="d-flex justify-content-between">
					<div className="pt-3 pb-3">
                        <b className='ad_150pct'>{gameType === 'free' ? <T>Upgrade this game to premium</T> : <T>Add more invitations to your game</T>}</b>
					</div>
				</div>
                <Row className="justify-content-center">
                    {gameType === 'free' && (
                        <Row className='d-flex'>
                            <Col xs={12} md={6}>
                                <ul>
                                    <li><T>Open to all assets</T></li>
                                    <li><T>Option for more than 30 participants</T></li>
                                    <li><T>Information and financial statements on assets</T></li>
                                </ul>
                            </Col>
                            <Col xs={12} md={6}>
                                <ul>
                                    <li><T>Trading in all countries - DK, SE, DE, US, ISL, FIN</T></li>
                                    <li><T>Option for games with ETFs, funds, crypto, bonds, and commodities</T></li>
                                    <li><T>Manage your participants</T></li>
                                </ul>
                            </Col>
                            <Col xs={12} className='pl-4 pt-1 pb-4'>
                                <Button onClick={triggerProUpgrade} className="ad_btn_purple ml-3 px-2 py-2"><T>Upgrade my game</T></Button>
                            </Col>
                        </Row>
                    )}
                    {gameType === 'pro' && (
                        <Col xs={12}>
                            <div className="py-2 font-small"><T>When you have completed the order, you will automatically gain access to more invitations</T></div>
                            <span>
                                <input className="ad_game_invite_ro_input ad_width_20_rem mb-2" value={props.render_static(<T>You have ${portfolioUpgrades.RemainingProInvites} invitations left</T>)} onClick={triggerBuyMoreInvites} readOnly={true} />
                                <span className="pl-md-2">
                                    <Butt className="ad_copy_link_btn align-top px-5" onClick={triggerBuyMoreInvites}><T>Add invitations</T></Butt>
                                </span>
                            </span>
                        </Col>
                    )}
                </Row>
			</Col>
            <Col xs="12" md="3" className="d-none d-md-block pl-2 pb-4">
                <img src='https://static.aktiedysten.dk/gfx/cart_markets.png' width={200} height={200} alt='Shopping cart with all markets' />
			</Col>
		</Row>
	);
}

const UpgradeGameWrapper = Apify("/a/portfolio_to_upgrade")
    .with_query_from_props((props) => ({game_id: props.game.Id}))
    .with_response_prop("portfolios_upgrade")
    .wrap(UpgradeGame);

const highlight_portfolio_ids = array2set([
	538777,
	538785,
	529665,
	539970,
]);

function IsGameAdminWrapper({ isGodOrAdmin, setIsGodOrAdmin }) {
	const prevIsGodOrAdminRef = React.useRef();

	React.useEffect(() => {
		if (prevIsGodOrAdminRef.current !== isGodOrAdmin) {
		setIsGodOrAdmin(isGodOrAdmin);
		prevIsGodOrAdminRef.current = isGodOrAdmin;
		}
	}, [isGodOrAdmin, setIsGodOrAdmin]);

	return null;
}

  const IsGameAdmin = Apify("/a/is_game_admin_or_god")
  .with_query_from_props(props => ({ game_id: props.game.Id }))
  .with_response_prop("isGodOrAdmin")  
  .wrap((props) => {
    return (
		<IsGameAdminWrapper
		  isGodOrAdmin={props.isGodOrAdmin} 
		  setIsGodOrAdmin={props.setIsGodOrAdmin} 
		/>
	  );
  });


const AdminActions = ({ loggedInUserId, game, portfolio, onUserBanned, onMoneyUpdate }) => {
	const modalData = {
		portfolioId: portfolio.Id,
		currency: game.Currency,
		userName: portfolio.OwnerScreenName,
		userId: portfolio.UserId,
		loggedInUserId: loggedInUserId,
		currentPortfolioValue: portfolio.Value,
		gameId: game.Id,
		onMoneyUpdate: onMoneyUpdate,
		onUserBanned: onUserBanned,
	  };


	const openAdminActionsModal = () => {
        AdminActionsModalInit(modalData);
    };

	return (
		<React.Fragment>
			<img 
				src='/gfx/gear-icon-0.svg' 
				alt="gear icon" 
				onClick={openAdminActionsModal} 
				style={{ cursor: 'pointer' }}
			/>
		</React.Fragment>
	);
};



class GameParticipants extends Component {
	constructor(props) {
		super(props);
		this.state = { tab: ["overview"], activeTab: 0, isGodOrAdmin: false, portfolios: props.game.Portfolios, betaPortfolios: props.game.BetaPortfolios, reloadCounter: 0 };
	}

	handleUserBanned = (bannedUserId) => {
		this.setState((prevState) => ({
		  portfolios: prevState.portfolios.filter(
			(portfolio) => portfolio.UserId !== bannedUserId
		  ),
		  betaPortfolios: prevState.betaPortfolios.filter(
			(portfolio) => portfolio.UserId !== bannedUserId
		  )
		}));
	  };
	  
	  handleMoneyUpdate = (updatedPortfolio) => {
		this.setState((prevState) => ({
		  portfolios: prevState.portfolios.map((p) =>
			p.Id === updatedPortfolio.Id ? { ...p, Value: updatedPortfolio.Value } : p
		  ),
		  betaPortfolios: prevState.betaPortfolios.map((p) =>
			p.Id === updatedPortfolio.Id ? { ...p, Value: updatedPortfolio.Value } : p
		  )
		}));
	  };

	render() {
        let portfolios = this.state.portfolios;

        if (this.state.activeTab === 1) {
            portfolios = this.state.betaPortfolios
        }

        let n_participants = portfolios.length;
		let my_portfolio_id = this.props.game.MyPortfolioId;

		const page_size = 10;
		const has_pagination = n_participants >= page_size*1.5;
		const tab0 = this.state.tab[0];
		const is_overview_tab = has_pagination && tab0 === "overview";
		const is_following_tab = has_pagination && tab0 === "following";

		var rows = [];

		const { my_placement } = placementAndNumPlayers(this.props.game, portfolios);

		const append_spacer_row = (pos) => {
			const Spacer = (props) => <div className="ad_game_participants_spacer"/>
			rows.push(
				<tr key={"spacer"+pos} className="ad_game_table_border">
					<td colSpan={100} className="px-0 py-0">
						<Spacer/>
						<Spacer/>
						<Spacer/>
						<Spacer/>
						<Spacer/>
					</td>
				</tr>
			);
		};

		const offset = tab0 === "offset" ? this.state.tab[1] : 0;
		var range_min = offset;
		var range_max = offset + page_size;

		var pos = 0;
		var last_emitted_pos = pos;
		var following_count = 0;
		for (const portfolio of portfolios) {
			pos++;
			const is_my_portfolio = my_portfolio_id === portfolio.Id;
			const is_following = portfolio.IsFollowing;
			if (is_following) following_count++;
			let is_highlighted_portfolio = highlight_portfolio_ids[portfolio.Id];
			if (has_pagination) {
				if (is_overview_tab) {
					if (pos > page_size && pos <= n_participants-2 && (my_placement === undefined || Math.abs(pos - my_placement) > 1) && !is_highlighted_portfolio) continue;
				} else if (is_following_tab) {
					if (!is_following && !is_my_portfolio) continue;
				} else {
					if ((pos-1) < range_min || (pos-1) >= range_max) {
						continue;
					}
				}
			}
			const alt = `#${pos}`;
			const badge = pos === 1 ? "/gfx/nr1-badge-game-0.svg" : "/gfx/generic-badge-game-0.svg";
			let row_class;
			if (is_my_portfolio) {
				row_class = "ad_game_own_portfolio_tr";
			} else if (is_highlighted_portfolio) {
				row_class = "ad_game_highlighted_portfolio_tr";
			} else {
				row_class = "ad_game_table_border";
			}
			row_class += " ad_grey_hover";
			const delta_money = portfolio.Value - this.props.game.InitialAmount;
			const delta_pct = ((portfolio.Value / this.props.game.InitialAmount) -1) * 100
			const suffix = " (" + this.props.render_static(I18N.floatval(delta_pct, 2)) + "%)";
			const change_money = <ChangeArrow currency_unit={this.props.game.Currency} pct={delta_money} suffix={suffix}/>
			const href = R.href("/portfolio/:id", {id: portfolio.Id});

			if (is_overview_tab && pos > (last_emitted_pos+1)) append_spacer_row(pos);

			rows.push(
				<tr className={row_class} key={portfolio.Id}>
					<td className="px-0 text-right">
						{pos}
					</td>
					<td className="px-3">
						<A className="d-block ad_no_hover" href={href}>
							<img src={badge} alt={alt}/>
						</A>
					</td>
					<td className="pl-0 mr-0 align-middle table-cell-min py-md-2"><A className="d-block ad_no_hover" href={href}>
						<span className="text-overflow-dynamic-container">
							<span className="text-overflow-dynamic-ellipsis">
								{portfolio.OwnerScreenName}
							</span>
						</span>
					</A></td>
					<td className="d-none d-sm-table-cell"><A className="d-block ad_no_hover" href={href}><span className="ad_game_table_gray">{portfolio.TradesCount}</span></A></td>
					<td className="d-none d-sm-table-cell"><A className="d-block ad_no_hover" href={href}>{change_money}</A></td>
					<td><span className="ad_game_table_gray"><A className="d-block ad_no_hover" href={href}>{I18N.floatval_unit(portfolio.Value, 2, this.props.game.Currency)}</A></span></td>
                    {this.props.game.RiskValues && this.state.activeTab === 1 && (
                        <td>
                            <span className="ad_game_table_gray">
                                <A className="d-block ad_no_hover" href={href}>
                                    {portfolio.BetaValue !== 0 ? I18N.floatval_unit(portfolio.BetaValue, 4) : I18N.floatval_unit(0, 4)}
                                </A>
                            </span>
                        </td>
                    )}
                    {this.props.game.RiskValues && this.state.activeTab === 1 && (
                        <td>
                            <span className="ad_game_table_gray">
                                <A className="d-block ad_no_hover" href={href}>
                                    {portfolio.BetaValue !== 0 ? I18N.floatval_unit(delta_pct / portfolio.BetaValue, 4): I18N.floatval_unit(0, 4)}%
                                </A>
                            </span>
                        </td>
                    )}
					{this.state.isGodOrAdmin && this.props.me && this.props.me.Subscription === 'pro' && <td className="d-none d-sm-table-cell"><AdminActions loggedInUserId={this.props.me.Id} game={this.props.game} portfolio={portfolio} onUserBanned={this.handleUserBanned} onMoneyUpdate={this.handleMoneyUpdate}/></td>}
				</tr>
			);
			last_emitted_pos = pos;
		}

		var pagination_ctrls;
		if (has_pagination) {
			const set_overview_tab = () => this.setState({tab: ["overview"]});
			const set_following_tab = () => this.setState({tab: ["following"]});
			const mk_set_offset_tab = (offset) => () => this.setState({tab: ["offset", offset]});

			const Ctrl = (props) => {
				var cls = "ad_game_participants_option ml-4";
				if (props.selected) {
					return <span className={cls + " ad_game_participants_option_selected"}>{props.children}</span>
				} else {
					return <ActionLink className={cls} on_click={props.on_click}>{props.children}</ActionLink>
				}
			};

			const is_last_offset = offset >= n_participants - page_size;
			const maybe_next_offset = offset + (is_last_offset ? 0 : page_size);

			const t_from = maybe_next_offset + 1;
			const t_to = Math.min(n_participants, maybe_next_offset+page_size);

			pagination_ctrls = (
				<div className="ad_no_select">
					<Ctrl selected={is_overview_tab} on_click={set_overview_tab}><T>Overview</T></Ctrl>
					{following_count > 0 && <Ctrl selected={is_following_tab} on_click={set_following_tab}><T>Following</T></Ctrl>}
					<Ctrl selected={is_last_offset} on_click={mk_set_offset_tab(maybe_next_offset)}>{t_from}&hellip;{t_to}</Ctrl>
				</div>
			);
		}

        const tabs = [<span><T>Value</T></span>, <span><T>Risk score</T></span>]

		

		return (
			<Row className="ad_game_box">
				 <IsGameAdmin 
					game={this.props.game} 
					setIsGodOrAdmin={(isGodOrAdmin) => {
						this.setState({ isGodOrAdmin });
					}} 
					/>
				<Col md="12" className="pl-2 pl-md-4 pt-4">
					<div className="d-flex">
						<div className="pb-0 ad_150pct mr-auto">
							<b><T>Game participants</T></b>
						</div>

						{pagination_ctrls}
					</div>
					{my_placement && <span className="pr-2 pt-0 font-small"><T>Your ranking: {my_placement}</T></span>}
                    {this.props.game.RiskValues && (
                        <Row className='pt-2'> 
                            <Col>
                                <XTab row_classes={["pb-2", "no_unselected_border"]} selected={this.state.activeTab} onSelect={(i) => this.setState({activeTab: i})} tabs={tabs}/>
                            </Col>
                        </Row>
                    )}
				</Col>
				<Col className="pl-2 pl-md-4">
					<Table className="table-borderless">
						<thead>
							<tr>
								<th className="ad_th_1px"/>
								<th className="ad_th_1px"/>
								<th><span className="ad_game_table_header"><T>NAME</T></span></th>
								<th className="d-none d-sm-table-cell"><span className="ad_game_table_header"><T>TRADES</T></span></th>
								<th className="d-none d-sm-table-cell"><span className="ad_game_table_header"><T>TOTAL CHANGE</T></span></th>
								<th><span className="ad_game_table_header"><T>VALUE</T></span></th>
                                {this.props.game.RiskValues && this.state.activeTab === 1 && (
                                    <th><span className="ad_game_table_header"><T>The risk score of the portfolio (Beta)</T></span></th>
                                )}
                                {this.props.game.RiskValues && this.state.activeTab === 1 && (
                                    <th><span className="ad_game_table_header"><T>The risk-adjusted return of the portfolio</T></span></th> 
                                )}
								{this.state.isGodOrAdmin && this.props.me && this.props.me.Subscription === 'pro' && <th className="d-none d-sm-table-cell"><span className="ad_game_table_header"><T>Admin Actions</T></span></th>}
							</tr>
						</thead>
						<tbody>
							{rows}
						</tbody>
					</Table>
				</Col>
			</Row>
		);
	}
}

const StartedGameImpl = (props) => {
	const right_now = (new Date()).getTime();
	const game_end_ms = props.game.EndTime * 1000;

	var invite;
	if (props.me && props.me.Id === props.game.HostUserId && right_now < game_end_ms) {
		invite = <Invite game_id={props.game.Id}/>;
	} else {
		invite = null;
	}
	var queued_trades;
	if (props.me && props.game && props.game.MyPortfolioId) {
		queued_trades = <QueuedTrades empty_class="pt-4" portfolio_id={props.game.MyPortfolioId}/>;
	} else {
		queued_trades = null;
	}

	var portfolio;
	if (props.game.MyPortfolioId > 0) {
		portfolio = (
			<Row className="ad_game_box">
				<Col md="12" className="ad_game_frontpage py-3">
					<PrivatePortfolio include_chart={true} portfolio_id={props.game.MyPortfolioId}/>
				</Col>
			</Row>
		);
	}

    if (props.cart && props.cart.completed === true && props.game && props.game.Id === props.cart.game_id) {
        props.game.GameType = 'pro'
    }

    var upgrade_game = null;
    if (props.me && props.me.Id === props.game.HostUserId && right_now < game_end_ms) {
        upgrade_game = <UpgradeGameWrapper {...props} />
    }

	return (
		<Container className="p-0">
			{portfolio}
			{queued_trades}
			{SR.render_game_middle()}
			<GameChat is_public={props.game.IsPublic} game_id={props.game.Id} admins={props.game.Admins} can_post={props.game.MyPortfolioId}/>
			{SR.render_game_lower_half()}
            {upgrade_game}
			{invite}
			<GameParticipants {...props}/>
		</Container>
	)
}

const StartedGame = (props) => <TraksConsumer><StartedGameImpl {...props}/></TraksConsumer>;

const EndedGameImpl = (props) => {
	const game_id = parseInt(props.game_id, 10);
	const {my_placement, number_of_players} = placementAndNumPlayers(props.game, props.game.Portfolios);

	var extra_text = <T>You finished no. <b>{my_placement}</b> out of <b>{number_of_players}</b> players.</T>;

	if(my_placement === 1) {
		if(number_of_players > 1) {
			extra_text = <T>Congratulations! You won by defeating <b>{number_of_players - 1}</b> other player(s)!</T>;
		} else {
			extra_text = "";
		}
	}

	if(my_placement > 1 && my_placement <= 3 && number_of_players > 3) {
		extra_text = <T>Good game - you made the podium! You finished no. <b>{my_placement}</b> out of <b>{number_of_players}</b> players.</T>;
	}

	if(my_placement > 3 && my_placement <= 10 && number_of_players > 10) {
		extra_text = <T>You made the top 10! You finished no. <b>{my_placement}</b> out of <b>{number_of_players}</b> players.</T>;
	}

	if(my_placement === number_of_players && number_of_players >= 25) {
		extra_text = <T>It's an achievement of its own to finish last out of <b>{number_of_players}</b> players. Better luck next time!</T>;
	}

	return (
		<Container>
			<h2 className="pt-4 align-self-start mr-auto">{props.game.Name}</h2>
			<div className="pt-3 ad_little_larger_txt"><T>The game has <i>ended</i>.</T>&nbsp;{extra_text}</div>
			<h2 className="pt-4 pb-3"><T>Game assets</T></h2>
			<Row className="ad_game_box">
				<Col md="12" className="py-3">
					<PrivatePortfolio include_chart={false} portfolio_id={props.game.MyPortfolioId}/>
					<RangedChart range_in="state" type="game" inner={LargeChartInner} game_id={game_id} portfolio_id={props.game.MyPortfolioId}/>
				</Col>
			</Row>
			<GameChat is_public={props.game.IsPublic} game_id={props.game.Id} admins={props.game.Admins} can_post={props.game.MyPortfolioId}/>
			<GameParticipants {...props}/>
			<div className="py-5"><T>Thanks for playing!</T></div>
		</Container>
	);
}

const EndedGame = (props) => <TraksConsumer><EndedGameImpl {...props}/></TraksConsumer>;

const scrollToId = (elem_id) => window.scrollTo({top: document.getElementById(elem_id).offsetTop-300, behaviour: 'smooth'});

const StartedGameLurkerMode = (props) => {
	const summary = <LurkerGameSummary game={props.game}/>;
	const chart = <RangedChart range_in="state" type="game_no_portfolio" inner={LargeChartInner} game_id={props.game.Id}/>;
	return (
		<React.Fragment>
			<Container className="p-0">
				{SR.render_game_header()}
				{summary}
				{chart}
			</Container>
			<div className="mb-4">
				<StartedGame {...props}/>
			</div>
		</React.Fragment>
	);
};

const PublicGames = Apify("/z/public_games")
	.with_query_from_props(props => ({site: current_site_id}))
	.with_response_prop("public_games")
.wrap(connect(
	(state) => ({
		xtab_index: state.home_public_games_xtab_index,
	})
)((props) => {
	const on_select = (i) => {
		store.dispatch_value("home_public_games_xtab_index", i);
	};

	const { xtab_index, public_games } = props;

	var cards = [];

	var n_all = 0;
	var n_prestart = 0;
	var n_started = 0;
	const use_xtab = coalesce(props.use_xtab, true);
	for (const game of public_games) {
		if (game.State === "prestart") {
			n_prestart++;
		} else if (game.State === "started") {
			n_started++;
		} else {
			continue;
		}
		n_all++;
	}

	if (n_all === 0 && !props.show_placeholder_if_empty) {
		return null;
	}

	for (const game of public_games) {
		var keep;
		if (use_xtab) {
			keep = (xtab_index === 0) || (xtab_index === 1 && game.State === "started") || (xtab_index === 2 && game.State === "prestart");
		} else {
			keep = game.State === "started" || game.State === "prestart";
		}
		if (!keep) continue;

		cards.push(
			<Col key={game.Id} md="4" className="p-3">
				<PublicGameCard {...game}/>
			</Col>
		);
	}

	if (n_all === 0) {
		/* Hack to display a coming soon message */
		cards.push(
			<Col key="42" className="p-4">
				<div className="ad_150pct"><T>Coming soon...</T></div>
				<div className="ad_pb-10">
					<T>Keep an eye on this space. We'll soon launch a bunch of public games
					with cool prizes here.</T>
				</div>
			</Col>
		);
	}

	var tabs;
	var derived_xtab_index;
	if (n_prestart === 0 && n_started > 0) {
		tabs = [
			<span><T>Current ({n_started})</T></span>,
		];
		derived_xtab_index = 0;
	} else if (n_prestart > 0 && n_started === 0) {
		tabs = [
			<span><T>Upcoming ({n_prestart})</T></span>,
		];
		derived_xtab_index = 0;
	} else  {
		tabs = [
			<span><T>All ({n_all})</T></span>,
			<span><T>Current ({n_started})</T></span>,
			<span><T>Upcoming ({n_prestart})</T></span>,
		];
		derived_xtab_index = xtab_index;
	}

	return (
		<Container className="pb-4">
			<Row className="pt-4">
				<Col xs="12" className="pt-3 text-center">
					<h1><T>Prize games. 100% free to participate!</T></h1>
					<p className="mt-2 mb-5 ad_gray_fg px-4 font-90">
					<T>Simply click one of the games below to join. You can join as many games as you want.</T>
					</p>
				</Col>
			</Row>
			<Row>
				<Col xs="12">
					<div className="d-flex">
					{use_xtab && <div className="ad_150pct" id="choose_a_game"><b><T>Prize games</T></b></div>}
					</div>
					{use_xtab && <XTab row_classes="pb-0" selected={derived_xtab_index} onSelect={on_select} tabs={tabs}/>}
				</Col>
				<Container fluid>
					<Row>
						{cards}
					</Row>
				</Container>
				{ IS_AKTIEKAMPEN_SE &&
				<Col xs="12" className="text-center pt-4">
					<a href="https://www.ungaaktiesparare.se" target="_blank" rel="noopener noreferrer" onClick={() => GoogleAnalytics.click_on_unga_aktiesparare()}>
						<img alt="Unga Aktiesparare" src="https://static.aktiedysten.dk/gfx/UngaAktiesparare-partner-350px-1.svg" />
					</a>
				</Col>
				}
			</Row>
		</Container>
	);
}));

const Padlocked = (props) => {
	const rid = useState(random_id())[0]
	const [ show_tooltip, set_show_tooltip ] = useState(false);
	const toggle = () => { set_show_tooltip(!show_tooltip); }
	return (
		<React.Fragment>
			<img alt="" id={rid} style={{position: "absolute", top: "-11.5px", right: "-11px"}} src="/gfx/padlock-icon-0.svg"/>
			<Tooltip placement="top" isOpen={show_tooltip} target={rid} toggle={toggle}>
				{props.locked_reason}
			</Tooltip>
		</React.Fragment>
	);
};

function MarketCard(props) {
	var ccls = 'text-center m-2 ad_card';
	var cprops = {};
	if (props.is_button && !props.locked) {
		cprops = {role: "button", tabIndex: "0", onClick: props.toggle, onKeyPress: props.toggle};
		ccls += ' ad_card_button';
	}
	if (props.selected) ccls += ' ad_card_button_selected';

	let icon;
	if (props.locked) {
		icon = <Padlocked locked_reason={props.locked_reason}/>
	} else if (props.selected) {
		icon = <img alt="" style={{position: "absolute", top: "-11.5px", right: "-11px"}} src="https://static.aktiedysten.dk/gfx/checkmark-icon-2023-0.svg"/>
	}

	return (
		<Card className={ccls} {...cprops}>
			<div style={{margin: "0 auto", textAlign: "center", display: "inline-block"}}>
				{icon}
				<CardBody>{props.children}</CardBody>
			</div>
		</Card>
	);
}

const available_markets = [
	{
		id: "DK_STOCK",
		img: "/gfx/denmark-icon-0.svg",
		alt: "Denmark",
		title: <T>Denmark</T>,
		text: <T>Nasdaq OMX Nordic</T>,
        section: 'stock',
		isPremium: false // default_market === 'DK_STOCK' ? false : true,
	},
	{
		id: "SE_STOCK",
		img: "/gfx/sweden-icon-0.svg",
		alt: "Sweden",
		title: <T>Sweden</T>,
		text: <T>Nasdaq OMX Nordic</T>,
        section: 'stock',
		isPremium: false // default_market === 'SE_STOCK' ? false : true,
	},
	{
		id: "FI_STOCK",
		img: "/gfx/finland-icon-0.svg",
		alt: "Finland",
		title: <T>Finland</T>,
		text: <T>Nasdaq OMX Nordic</T>,
        section: 'stock',
		isPremium: false // default_market === 'FI_STOCK' ? false : true,
	},
	{
		id: "IS_STOCK",
		img: "/gfx/iceland-icon-0.svg",
		alt: "Iceland",
		title: <T>Iceland</T>,
		text: <T>Nasdaq OMX Nordic</T>,
        section: 'stock',
		isPremium: false // default_market === 'IS_STOCK' ? false : true,
	},
	{
		id: "US_STOCK",
		img: "/gfx/usa-icon-0.svg",
		alt: "United States of America",
		title: <T>USA</T>,
		text: <T>NYSE &amp; Nasdaq</T>,
        section: 'stock',
		isPremium: false // default_market === 'US_STOCK' ? false : true,
	},
	{
		id: "DE_STOCK",
		img: "/gfx/germany-icon-0.svg",
		alt: "Germany",
		title: <T>Germany</T>,
		text: <span>Frankfurt (XETRA)</span>,
        section: 'stock',
		isPremium: false // default_market === 'DE_STOCK' ? false : true,
	},
	{
		id: "AT_STOCK",
		img: "/gfx/austria-icon-0.svg",
		alt: "Austria",
		title: <T>Austria</T>,
		text: <T>Vienna Stock Exchange</T>,
        section: 'stock',
		isPremium: false // default_market === 'AT_STOCK' ? false : true,
	},
	{
		id: "CRYPTOCURRENCIES",
		img: "/gfx/crypto-icon-0.svg",
		alt: "Crypto currencies",
		title: <T>Crypto</T>,
		text: <T>Several crypto currencies</T>,
        section: 'crypto',
		isPremium: true,
	},
	{
		id: "COMMODITIES",
		img: "/gfx/commodities-icon-0.svg",
		alt: "Commodities",
		title: <T>Commodities</T>,
		text: <T>(metals, oil, etc.)</T>,
        section: 'commodity',
		isPremium: true,
	},
    {
        id: "ETFS",
        img: "/gfx/eft-icon-0.svg",
        alt: "ETFs",
        title: <T>ETFs</T>,
        text: <T>(EFT - Exchange-Traded Funds)</T>,
        section: 'assets',
        isPremium: true,
    },
    {
        id: "INDEXES",
        img: "/gfx/indexes-icon-0.svg",
        alt: "ETFs",
        title: <T>Indexes</T>,
        text: <T>(Investment fund)</T>,
        section: 'assets',
        isPremium: true,
    },
    {
        id: "FUNDS",
        img: "/gfx/funds-and-bonds-icon-0.svg",
        alt: "Funds and Bonds",
        title: <T>Funds and Bonds</T>,
        text: <T>(Mutual fund or exchange-traded fund)</T>,
        section: 'assets',
        isPremium: true,
    }
];

const get_market_data_by_id = (id) => {
	for (const market of available_markets) if (market.id === id) return market;
	return null;
}

const MarketCards = (props) => {
	var mk_market_card_props, is_button;
	if (props.mk_market_card_props) {
		mk_market_card_props = props.mk_market_card_props;
		is_button = true;
	} else {
		mk_market_card_props = () => ({});
		is_button = false;
	}

    var justify = 'center';
    if (props.justify) {
        justify = props.justify;
    }

	const locked_market_set = array2set(props.locked_markets);

	var market_set;
	if (props.markets) market_set = array2set(props.markets);

	const should_include = (market_id) => {
		if (market_set) {
			return market_set[market_id];
		} else {
			return true;
		}
	};

	const ordered_markets = [...available_markets]
  .filter(x => market_order_key_map[x.id] !== undefined)
  .sort((a, b) => (market_order_key_map[a.id] || 0) - (market_order_key_map[b.id] || 0));

var market_components = [];
for (const mo of ordered_markets) {
  const { id, img, alt, title, text, section, isPremium } = mo; 
  if (!should_include(id)) continue;
  if (id === 'AT_STOCK') continue;
  if (props.section && section !== props.section) continue;

  market_components.push(
    <MarketCard key={id} locked={locked_market_set[id]} is_button={is_button} locked_reason={props.locked_reason} {...mk_market_card_props(id, isPremium)}>
      {isPremium && (
        <div className="ad_market_premium_badge">Premium</div>
      )}
      <CardImg top className="ad_market_card_img" src={img} alt={alt} />
      <div className="ad_card_title">{title}</div>
      <div className="ad_card_text">{text}</div>
    </MarketCard>
  );
}
	var cols = [];
	var key = 1;
	for (const col of segmentize(4, market_components)) {
		const md = col.length * 3;
		cols.push(
			<Col key={key} md={md} className="px-md-4 pt-4">
				<CardDeck className="pl-2 pr-sm-2 pt-2">
					{col}
				</CardDeck>
			</Col>
		);
		key++;
	}

	if (cols.length === 0) return null;

	return (
		<Row className={`justify-content-${justify}`}>
			{cols}
		</Row>
	);
};

const SorryYouAreTooLate = (props) => {
	const start_new_game = () => R.go("/new_game");
	const ended_game_txt = <div><T>The game has ended, but you can <Butt className="ad_btn_sm mx-1" onClick={start_new_game}><b>start your own game</b></Butt> and invite your friends.</T></div>;

	return (
		<div className="container-fluid ad_pb-10">
			<Row className="pt-5 pb-5">
				<Col className="mt-2" align="center">
					<img src="/gfx/pokal_m_flimmer-0.svg" className="img-fluid" alt="Time for a new game!"/>
				</Col>
			</Row>
			<Row className="ad_pb-10">
				<Col className="text-center">
					<h2 className="pb-3">
					<T>The game has already ended!</T>
					</h2>
					{ended_game_txt}
				</Col>
			</Row>
		</div>
	);
}

const GameOverviewInner = (props) => {
	const { game_id, game, mode, aua, eula_components } = props;

	if (game.State === "ended") {
		return <SorryYouAreTooLate/>
	}

	const { me } = aua;

	const offset0 = 168;
	const offset1 = 35;

	const [err, set_err] = useState("");
	const [email, set_email] = useState("");

	let eulas_accepted_initial_value = [];
	for (let i = 0; i < eula_components.length; i++) eulas_accepted_initial_value.push(false);
	const [eula_component_values, set_eula_component_values] = useState(eulas_accepted_initial_value);

	const [ join_game_payload, set_join_game_payload ] = useState(null);

	const merge_join_game_payload = (payload) => {
		set_join_game_payload((old_payload) => {
			if (!old_payload) {
				return payload;
			} else {
				return {...old_payload, ...payload};
			}
		});
	};

	var now = Date.now()/1000;
	let time_element;

	let duration = null, duration_element = null;

	if (game.StartTime > now) {
		time_element = (
			<React.Fragment>
				<h2><T>The game starts</T></h2>
				<h2><strong>{I18N.datetime_short(new Date(game.StartTime*1000))}</strong></h2>
			</React.Fragment>
		);

		duration = game.EndTime - game.StartTime;
	} else if (game.EndTime > now) {
		time_element = (
			<React.Fragment>
				<h2><T>The game ends</T></h2>
				<h2><strong>{I18N.datetime_short(new Date(game.EndTime*1000))}</strong></h2>
			</React.Fragment>
		);
	} else {
		time_element = (
			<React.Fragment>
				<h2><T>The game has ended</T></h2>
			</React.Fragment>
		);
	}
	if(duration && duration >= 24 * 60 * 60) {
		const duration_days = Math.round(duration / (24 * 60 * 60));
		duration_element = (
			<Col md="4" className="d-flex flex-column pt-4">
				<div className="ad_gamepage_infobox mr-1 text-center py-4 px-4 h-100">
					<InlineSVG src="/gfx/gamepage-duration-days-0.svg"/>
					<h1><T context="invite_game_page">Duration</T></h1>
					<h2><T>The game runs for</T></h2>
					<h2><strong><T>{duration_days} day(s)</T></strong></h2>
				</div>
			</Col>
		);
	}
	var brokerage_element;
	if (game.BrokeragePct === 0) {
		brokerage_element = <T>There is <strong>no</strong> brokerage in this game</T>;
	} else {
		brokerage_element = <React.Fragment>{I18N.floatval(game.BrokeragePct, 2)}%</React.Fragment>;
	}

	var max_amount_per_stock_element;
	if (game.MaxAmountPerStock === 0) {
		max_amount_per_stock_element = <T>There is <strong>no</strong> limit on equity purchase</T>;
	} else {
		max_amount_per_stock_element = <T>You can max. buy for <strong>{I18N.floatval_unit(game.MaxAmountPerStock, 2, game.Currency)}</strong> per equity</T>;
	}

	const is_logged_in = !!me;

	var trophy_src, top_title, rest_of_whitebox, more_stuff_after_whitebox;
	if (mode === "invite") {
		trophy_src = "/gfx/trophy-header-0.svg";
		top_title = <T>Invitation for</T>;
		const invite_key = props.invite_key || "";

		const maybe_get_join_game_payload = () => JSON.stringify(join_game_payload) || undefined;

		const do_join = () => {
			const payload = maybe_get_join_game_payload();
			API.post("/a/accept_game_invite", {game_id, key: invite_key, payload}, (was_accepted) => {
				if (was_accepted) {
					goto_game(game_id);
				} else {
					/* could not be accepted;
					 * reload page to see why */
					window.location.reload();
				}
			});
		};

		const show_email_input_field = game.RequireEmail && me && !me.LocalEmail;
		const maybe_check_email_and_then_join = () => {
			const has_entered_email = show_email_input_field && email.trim().length > 0;
			if (has_entered_email) {
				aua.request.set_email_and_join_game(email, game_id, invite_key, maybe_get_join_game_payload(), (err) => {
					if (err) {
						set_err(err.code);
					} else {
						// unreachable
					}
				});
			} else {
				do_join();
			}
		};

		const signuplogin_before_join = () => {
			OpenSignupAndJoinGame(game_id, invite_key, maybe_get_join_game_payload());
		};

		const do_join_game = is_logged_in ? maybe_check_email_and_then_join : signuplogin_before_join;

		const errcls = (has_error, cls) => cls + (has_error ? " ad_input_error" : "");

		var error_element;
		var has_email_input_error = false;
		switch (err) {
		case "":
			break;
		case "email_conflict":
			error_element = <T>The email address is being used by another account</T>;
			has_email_input_error = true;
			break;
		case "email_invalid":
			error_element = <T>You must enter a valid email address</T>;
			has_email_input_error = true;
			break;
		default:
			error_element = <React.Fragment>{err}</React.Fragment>
			break;
		}

		var email_element;
		if (show_email_input_field) {
			const enter_email_txt = game.RequireEmail
				? <small><T>Enter your e-mail. This is required to win a prize. Your email will <b>not</b> be used for unwanted marketing.</T></small>
				: <small><T>Enter your e-mail to get info about the game. Your email will <b>not</b> be used for unwanted marketing.</T></small>

			const on_change = (e) => {
				set_email(e.target.value);
			};

			email_element = (
				<Row className="justify-content-center">
					<Col md="12" className="px-md-4 pt-4">
						<img alt="" className="ad_logo_list" src="/gfx/at-sign-icon-0.svg"/><span className="ad_120_bold pl-2"><T>Enter your e-mail</T></span>
						<p>{enter_email_txt}</p>
						<div className="ad_newgame_formgroup pt-2">
							<div className="input-group">
								<input
									name="email"
									value={email}
									onChange={on_change}
									placeholder="E-mail"
									className={errcls(has_email_input_error, "ad_input ad_3px_radius ad_height_60px w-100 pl-3 mb-4")}
									type="email"
								/>
							</div>
						</div>
					</Col>
				</Row>
			);
		}

		const nowTs = Date.now()
		let inviteEndTs = 0;
		if (game.InviteEndTs !== null) {
			inviteEndTs = new Date(game.InviteEndTs).getTime();
		}

        const info = props.info;

		var is_full = false;
		var remaining_invites_element;
		if (inviteEndTs !== 0 && inviteEndTs >= 0 && inviteEndTs < nowTs) {
			remaining_invites_element = (
			  <div className='ad_gamepage_infobox warning py-4 px-4 text-center'>
				<T>Sorry, the time for invitations has expired</T>
			  </div>
			);
			is_full = true;
		  } else if (((info.RemainingFreeInvites > 0 && game.GameType === 'free') || (info.RemainingProInvites > 0 && game.GameType === 'pro')) && info.HasSkinId === false) {
			remaining_invites_element = (
			  <div className='ad_gamepage_infobox py-4 px-4 text-center'>
				<T>There are <b>{game.GameType === 'free' ? info.RemainingFreeInvites : info.RemainingProInvites}</b> remaining invites</T>
			  </div>
			);
		  } else if (((info.RemainingFreeInvites === 0 && game.GameType === 'free') || (info.RemainingProInvites > 0 && game.GameType === 'pro')) && info.HasSkinId === false) {
			remaining_invites_element = (
			  <div className='ad_gamepage_infobox warning py-4 px-4 text-center'>
				<T>Sorry, the game is full</T>
			  </div>
			);
			is_full = true;
		  } else {
			remaining_invites_element = null;
		  }

		let eula_elements = [];
		let all_eulas_accepted = true;
		if (game.MustAcceptEULA) {
			const mk_set = (index) => (new_value) => {
				let new_values = [];
				for (let i = 0; i < eula_components.length; i++) new_values.push(i === index ? new_value : eula_component_values[i]);
				set_eula_component_values(new_values);
			};
			const mk_toggle = (index) => () => {
				mk_set(index)(!eula_component_values[index]);
			};
			for (let i = 0; i < eula_components.length; i++) {
				const EulaComponent = eula_components[i];
				eula_elements.push(
					<EulaComponent key={i} value={eula_component_values[i]} set={mk_set(i)} toggle={mk_toggle(i)} set_join_game_payload={merge_join_game_payload}/>
				);
				if (!eula_component_values[i]) all_eulas_accepted = false;
			}
		}
		const join_game_enabled = !game.MustAcceptEULA || all_eulas_accepted;

		rest_of_whitebox = (
			<React.Fragment>
				<Container>
					{remaining_invites_element}
					<Row className="d-flex flex-wrap">
						<Col md="4" className="d-flex flex-column pt-4">
							<div className="ad_gamepage_infobox mr-1 text-center py-4 px-4 h-100">
								<InlineSVG src="/gfx/gamepage-duration-0.svg"/>
								<h1><T context="invite_game_page">Game time</T></h1>
								{time_element}
							</div>
						</Col>
						{duration_element}
						<Col md="4" className="d-flex flex-column pt-4">
							<div className="ad_gamepage_infobox mx-1 text-center py-4 px-4 h-100">
								<InlineSVG src="/gfx/gamepage-bankroll-0.svg"/>
								<h1><T>Bankroll</T></h1>
								<h2><T>Initial bankroll is</T></h2>
								<h2><strong>{I18N.floatval_unit(game.InitialAmount, 2, game.Currency)}</strong></h2>
							</div>
						</Col>
						<Col md="4" className="d-flex flex-column pt-4">
							<div className="ad_gamepage_infobox ml-1 text-center py-4 px-4 h-100">
								<InlineSVG src="/gfx/gamepage-brokerage-0.svg"/>
								<h1><T>Brokerage</T></h1>
								<h2>{brokerage_element}</h2>
							</div>
						</Col>
						<Col md="4" className="d-flex flex-column pt-4">
							<div className="ad_gamepage_infobox ml-1 text-center py-4 px-4 h-100">
								<InlineSVG src="/gfx/gamepage-max1equity-0.svg"/>
								<h1><T>Max. amount per equity</T></h1>
								<h2>{max_amount_per_stock_element}</h2>
							</div>
						</Col>
					</Row>
					<Row className="pt-4">
						<Col md="12">
							<div className="ad_gamepage_infobox mx-1 text-center py-4 px-4">
								<InlineSVG src="/gfx/gamepage-markets-0.svg"/>
								<h1><T>Markets</T></h1>
								<div className="ad_invite_market_cards">
									<MarketCards markets={game.Markets} />
								</div>
							</div>
						</Col>
					</Row>
				</Container>
				{!is_full && (
					<div className="text-center pt-5">
						{email_element}
						{error_element}
						{eula_elements}
						<Butt disabled={!join_game_enabled} className="ad_accept_game_invite_btn py-3 px-5" id="master_join_game_button" onClick={do_join_game}><T>Join game</T></Butt>
					</div>
				)}
				<div className="text-center mt-5 mb-4">
					{SR.render_game_info()}
				</div>
			</React.Fragment>
		);
	} else if (mode === "pending") {
		trophy_src = "/gfx/trophy-header-check-0.svg";
		top_title = <T>You have joined</T>;
		rest_of_whitebox = (
			<React.Fragment>
				<div className="d-flex justify-content-center pb-4">
					<div className="ad_gamepage_infobox text-center py-4 px-4">
						{time_element}
					</div>
				</div>

			</React.Fragment>
		);


		var portfolios = game.Portfolios;
		var participants = portfolios.sort((a,b) => a.Id-b.Id).map((p) => {
			return <Col xs="4" key={p.Id} className="mb-1 ad_soft">{p.OwnerScreenName}</Col>
		});

		var n_participants;
		if (portfolios.length >= 7) {
			n_participants = <span className="ad_soft"> ({portfolios.length} participants)</span>
		}

		var invite_possibly;
		if (me && me.Id === game.HostUserId) {
			invite_possibly = <Invite game_id={game.Id}/>
		}

		more_stuff_after_whitebox = (
			<Container>
				{invite_possibly}
				{SR.render_game_middle()}
				<GameChat is_public={props.game.IsPublic} game_id={game_id} admins={game.Admins} can_post={game.MyPortfolioId}/>
				<Row className="ad_game_box p-4 my-4">
					<h2 className="pb-4"><T>Game participants</T>{n_participants}</h2>
					<Container className="p-0">
						<Row className="overflow-hidden">
							{participants}
						</Row>
					</Container>
				</Row>
			</Container>
		)
	}

	let can_admin = false;
	if(me && me.Id) {
		can_admin = array2set(game.Admins)[me.Id];
	}
	let edit_game_button;
	if (can_admin) {
		edit_game_button = (
			<A className="ad_edit_game_link ad_edit_game_link_darkmod"  href={R.href("/edit_game/:game_id", {game_id: game.Id})}>
				<span className="pl-2">
					<img className="ad_edit_game_icon" alt="change game" src="/gfx/anothergear-dark-icon-0.svg" />
					<T context="Edit game">Edit</T>
				</span>
			</A>
		);
	}

	return (
		<React.Fragment>
			{SR.render_game_subtitle()}
			<div className="ad_trophy_header text-center">
				<InlineSVG src={trophy_src}/>
			</div>
			<WhiteBox className="pt-4 pb-4" style={{marginTop: -offset0 + "px"}}>
				<div className="text-center">
					<div className="ad_gamepage_h0" style={{marginTop: (offset0-offset1) + "px"}}>
						{top_title}
					</div>
					<div className="ad_gamepage_h1 mt-1 pb-3">
						{game.Name}
						{edit_game_button}
					</div>
					{(!is_full && props.mode === "invite") && (
						<div className="text-center pt-3 pb-4">
							<Button className="ad_accept_game_invite_btn py-3 px-5" onClick={() => scrollToId('master_join_game_button')}><T>Join game</T></Button>
						</div>
					)}
					{SR.render_game_logo()}
				</div>
				{rest_of_whitebox}
			</WhiteBox>
			{more_stuff_after_whitebox}
		</React.Fragment>
	);
};

const GameOverview = (props) => {
	const Wrapper = (props) => {
		// XXX call get_eula_components() here instead of calling it
		// for each render inside <GameOverviewInner/>; besides
		// probably improving performance, it also seems to prevent the
		// components from losing state (I'm not entirely sure how it
		// works internally, but it seems that component state cannot
		// survive making the constructor from scratch all the time)
		let eula_components = props.skin.get_eula_components();
		return <GameOverviewInner {...props} eula_components={eula_components}/>
	};

	return (
		<SkinWrapperByGameOrPortfolioId game_id={props.game_id}>
			<SkinContext.Consumer>{skin => <Wrapper {...props} skin={skin}/>}</SkinContext.Consumer>
		</SkinWrapperByGameOrPortfolioId>
	);
};

const InvitePageReally = ApifyParallel(
    Apify('/a/game').with_query_from_props((props) => ({ id: props.game_id, invite_key: props.invite_key })).with_response_prop('game'),
    Apify('/z/user_keys_by_game').with_query_from_props((props) => ({ game_id: props.game_id, site: short_site_id })).with_response_prop('info')
 ).wrap((props) => {
    return (
      <AUAContainer>
        <GameOverview mode="invite" {...props} />
      </AUAContainer>
    )
  })

const goto_game = (game_id) => {
	R.replace("/game/:id", {id: game_id});
}

class CheckIfPartOfGameFirst extends Component {
	componentDidMount() {
		if (this.props.is_part_of_game) {
			goto_game(this.props.game_id);
			return null;
		}
	}

	render() {
		if (!this.props.is_part_of_game) {
			return <InvitePageReally {...this.props}/>;
		} else {
			return null;
		}
	}
}

CheckIfPartOfGameFirst = Apify("/a/part_of_game")
	.with_query_from_props(props => ({game_id: props.game_id}))
	.with_response_prop("is_part_of_game")
	.wrap(CheckIfPartOfGameFirst, ApifyFullScreenLoadingComponent);

const InvitePage = connect(
	(state) => ({me: state.me})
)((props) => {
	if (props.me) {
		return <CheckIfPartOfGameFirst {...props}/>
	} else {
		return <InvitePageReally {...props}/>
	}
});


const PendingGame = (props) => {
	return (
		<AUAContainer>
			<GameOverview mode="pending" {...props}/>
		</AUAContainer>
	);
}

const gamify = (wrapped_component) => {
	return Apify("/a/game")
		.with_query_from_props(props => ({id: props.game_id}))
		.with_response_prop("game")
		.wrap(wrapped_component, ApifyFullScreenLoadingComponent);
};

const ApifiedPendingGame = gamify(PendingGame);
//const ApifiedStartedGame = gamify(StartedGame);
const ApifiedStartedGameLurkerMode = gamify(StartedGameLurkerMode)
const ApifiedEndedGame = gamify(EndedGame);

var GameComp = (props) => {
	if (props.not_found) {
		/* a 404 can mean several things; 1) the game id does not
		 * exist; 2a) you don't have access to the game because you're
		 * not logged in; 2b) you don't have access to the game because
		 * it is not public */
		const is_logged_in = !!props.me;
		if (!is_logged_in) {
			OpenLoginWithSuccessCallback(() => {
				props.ctl.reload();
			});
		} else {
			R.replace("/");
		}
		return null;
	} else {
		/* a 200 means you have access to the game, either because you
		 * already have a portfolio in the game (whether or not it is
		 * public), or because it is a public game that can be viewed
		 * by anyone) */
		const my_portfolio_id = props.gamepeek.PortfolioId;
		const state = props.gamepeek.State;

		// go to invite page if
		//   1) game is not yet started (state = "prestart")
		//   2) you're not logged in, or you haven't joined the game
		//      (portfolio id = 0)
		//   3) game is public (/a/game_peek responds with 404 if not)
		if (state === "prestart" && my_portfolio_id === 0) {
			R.go("/invite/:id", {id: props.game_id});
			return <div>...</div>;
		}

		switch (state) {
		case "prestart":
			return <ApifiedPendingGame {...props}/>
		case "ended":
			return <ApifiedEndedGame {...props}/>
		case "started":
			if (my_portfolio_id === 0) {
				/* public game, but you don't have a portfolio
				 * in it, or you're not logged in; allow
				 * lurking under the /game/:id path */
				return <ApifiedStartedGameLurkerMode {...props}/>
			} else {
				/* when logged in and you have a portfolio in
				 * the game, then the front-page is the game
				 * page; set the "current game" and go the
				 * front-page */
                store.dispatch_value("LastGamePortfolioIdVisited", my_portfolio_id);
				R.replace("/");
				return <div>...</div>;
			}
		default:
			throw new Error("invalid state");
		}
	}
}

GameComp = Apify("/a/game_peek")
	.with_query_from_props(props => ({id: props.game_id}))
	.with_response_prop("gamepeek")
	.with_4xx_prop("not_found")
	.with_ctl_prop("ctl")
	.wrap(GameComp, ApifyFullScreenLoadingComponent);


var GamePage = connect(
	(state) => ({
        me: state.me,
    })
)((props) => {
	return (
		<SkinWrapperByGameOrPortfolioId game_id={props.game_id}>
			<GameComp {...props}/>
		</SkinWrapperByGameOrPortfolioId>
	);
});

export { StartedGame, GamePage, InvitePage, PublicGames, ActiveGameSummary, MarketCards, available_markets, get_market_data_by_id, QuotesFromPeople };



// WEBPACK FOOTER //
// ./src/c/Game.js